var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.available
    ? _c(
        "button",
        {
          staticClass:
            "h-6 px-2 flex items-center text-xs rounded-sm border whitespace-no-wrap",
          style: _vm.style,
          attrs: {
            "data-test": "subscribe-button",
            "aria-label": _vm.$t(_vm.a11y.key, _vm.a11y.attr)
          },
          on: { click: _vm.show }
        },
        [
          _c("icon", {
            staticClass: "mr-1",
            attrs: { "aria-hidden": "true", type: "plus" }
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("SUBSCRIBE")))])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }